import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { cn } from "ui";

import { SectionFormatIcon } from "src/workouts/SectionFormatIcon";
import { useWorkoutEditStore } from "src/workouts/WorkoutEditContext";

import { type MinimapSectionItemProps } from "./BaseMinimapSectionItem";
import { MinimapItemBase } from "./MinimapItemBase";

export const SupersetMinimapSectionItem = observer(
  function SupersetMinimapSectionItem(props: MinimapSectionItemProps) {
    const { t } = useTranslation();
    const workoutEditStore = useWorkoutEditStore();
    const workoutItem = workoutEditStore.getGroupWorkoutItemById(props.id);

    const displayName =
      workoutEditStore.getWorkoutItemName(workoutItem.id) ||
      t("editWorkout.defaultGroupName");

    return (
      <MinimapItemBase
        id={props.id}
        level={props.level}
        index={props.index}
        previousItemId={props.previousItemId}
        displayName={displayName}
        className={cn({
          "pt-2": props.index === 0 && !!workoutItem.parentId,
        })}
        nestedItems={props.children}
      >
        <span className="shrink-0">
          <SectionFormatIcon format={null} />
        </span>
        <span className="text-xs truncate flex-1 min-w-0 font-medium text-amber-700">
          {displayName}
        </span>
        {props.childCount > 0 ? (
          <span className="text-[10px] px-1 py-0 rounded shrink-0 bg-amber-100 text-amber-700">
            {props.childCount}
          </span>
        ) : null}
      </MinimapItemBase>
    );
  },
);
